<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'sm'">
    <fudis-heading [level]="2">{{ title }}</fudis-heading>
    <fudis-dialog-content>
      @if (contentHtml) {
        <sis-localized-markup-string-view [content]="contentHtml" />
      }
      @if (contentTranslateKey) {
        <transloco [key]="contentTranslateKey" [params]="contentTranslateParameters"></transloco>
      }
    </fudis-dialog-content>
  </fudis-dialog>
</ng-container>
